import { useContext } from 'react';
import { ActivityViewContext } from '../context/ActivityViewContext';

const useActivityView = () => useContext(ActivityViewContext);

export default useActivityView;
